import React from "react";
import middleware from "./middleware/middleware";
import AllPositionsUserSitePublisher from "../component/sections/position/AllPositions";
import AddPositionsUserSitePublisher from "../component/sections/position/AddPositions";
import ViewPositionUserSitePublisher from "../component/sections/position/ViewPositions";
import EditPositionUserSitePublisher from "../component/sections/position/EditPositions";
import AllPositionsIndependentInWebSitePublisher from "../component/sections/position/independent/AllPositions";
import AddPositionsIndependentInWebSitePublisher from "../component/sections/position/independent/AddPositions";
import ViewPositionIndependentUserSitePublisher from "../component/sections/position/independent/ViewPositions";
import EditPositionIndependentUserSitePublisher from "../component/sections/position/independent/EditPositions";
import PositionsList from "../component/sections/position/PositionsList";
import ReportPosition from "../component/sections/position/ReportPosition";

const sitesRoutes = [
  {
    path: "/positions/all/page/:pageID",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AllPositionsUserSitePublisher />,
        "AllPositionsUserSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/positions/add/page/:pageID",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AddPositionsUserSitePublisher />,
        "AddPositionsUserSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/positions/:positionID/view",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <ViewPositionUserSitePublisher />,
        "ViewPositionUserSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/positions/:positionID/edit",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <EditPositionUserSitePublisher />,
        "EditPositionUserSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/positions/independent/all/web-site-publisher/:publisherID",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AllPositionsIndependentInWebSitePublisher />,
        "AllPositionsIndependentInWebSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/positions/independent/add/web-site-publisher/:publisherID",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AddPositionsIndependentInWebSitePublisher />,
        "AddPositionsIndependentInWebSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/positions/independent/:positionID/view",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <ViewPositionIndependentUserSitePublisher />,
        "ViewPositionIndependentUserSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/positions/independent/:positionID/edit",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <EditPositionIndependentUserSitePublisher />,
        "EditPositionIndependentUserSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/positions/report-position",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <ReportPosition />,
        "ReportPosition"
      );
    },
    exact: true,
  },
  {
    path: "/positions/list",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <PositionsList />,
        "PositionsList"
      );
    },
    exact: true,
  },
];

export default sitesRoutes;
